import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        palomma: {
          50: { value: "#f4f0ff" },
          100: { value: "#e6dbff" },
          200: { value: "#d0b8ff" },
          300: { value: "#b38eff" },
          400: { value: "#8e5cff" },
          500: { value: "#4012AB" }, // Primary Brand Color
          600: { value: "#320e8a" },
          700: { value: "#260a69" },
          800: { value: "#1b074a" },
          900: { value: "#11032e" },
          950: { value: "#09011a" },
        },
      },
      fonts: {
        heading: { value: "Rethink Sans, sans-serif" },
        body: { value: "Geist, sans-serif" },
      },
    },
    semanticTokens: {
      colors: {
        colorPalette: {
          50: { value: "{colors.palomma.50}" },
          100: { value: "{colors.palomma.100}" },
          200: { value: "{colors.palomma.200}" },
          300: { value: "{colors.palomma.300}" },
          400: { value: "{colors.palomma.400}" },
          500: { value: "{colors.palomma.500}" },
          600: { value: "{colors.palomma.600}" },
          700: { value: "{colors.palomma.700}" },
          800: { value: "{colors.palomma.800}" },
          900: { value: "{colors.palomma.900}" },
          950: { value: "{colors.palomma.950}" },
          contrast: { value: "white" },
          fg: {
            value: {
              base: "{colors.palomma.700}",
              _dark: "{colors.palomma.300}",
            },
          },
          subtle: {
            value: {
              base: "{colors.palomma.100}",
              _dark: "{colors.palomma.900}",
            },
          },
          muted: {
            value: {
              base: "{colors.palomma.200}",
              _dark: "{colors.palomma.800}",
            },
          },
          emphasized: {
            value: {
              base: "{colors.palomma.300}",
              _dark: "{colors.palomma.700}",
            },
          },
          solid: {
            value: {
              base: "{colors.palomma.600}",
              _dark: "{colors.palomma.600}",
            },
          },
          focusRing: {
            value: {
              base: "{colors.palomma.500}",
              _dark: "{colors.palomma.500}",
            },
          },
          border: {
            value: {
              base: "{colors.palomma.500}",
              _dark: "{colors.palomma.400}",
            },
          },
        },

        primary: { value: "{colors.palomma.500}" },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
